import { AuthState } from "../base/AuthState";
import { initHeroShader, destroyHeroShader } from '../../components/hero-shader';
import { trackSignUp } from '../../core/Analytics';

import template from './RegisterTemplate.html';
import * as IF from "infrontjs";

export class RegisterState extends AuthState
{
    static ROUTE = '/register';
    static ID = 'register';

    async enter()
    {
        const mainWrapper = this.app.container.querySelector('#main-wrapper' );
        this.app.view.render(
            mainWrapper,
            template
        );

        initHeroShader( mainWrapper.querySelector( '#hero-shader' ) );

        // Pre-select saved region
        const savedRegion = this.app.storage.loadRegion();
        if ( savedRegion )
        {
            mainWrapper.querySelector( '[data-id="select-region"]' ).value = savedRegion;
        }

        this.addEventListener(
            mainWrapper.querySelector( '[data-id="btn-register"]' ),
            'click',
            async ( e ) => {
                mainWrapper.querySelector( '[data-id="register-error-container"]' ).style.display = 'none';
                const form = mainWrapper.querySelector( '[data-id="form-register"]' );
                if ( true === form.checkValidity() )
                {
                    mainWrapper.querySelector( '[data-id="btn-register"]' ).style.display = 'none';
                    mainWrapper.querySelector( '[data-id="btn-register-loading"]' ).style.display = 'block';
                    const userData = IF.Helper.serializeForm( form );

                    // Save region and update API endpoint
                    this.app.storage.saveRegion( userData.region );
                    this.app.api.setRegion( userData.region );

                    try
                    {
                        const { result } = await this.app.api.post(
                            '/auth/user',
                            {
                                name: userData.name,
                                email : userData.email,
                                password: userData.password
                            }
                        );
                        if ( +result.status === 201 )
                        {
                            mainWrapper.querySelector( '[data-id="register-form-container"]' ).style.display = 'none';
                            mainWrapper.querySelector( '[data-id="register-success-container"]' ).style.display = 'block';
                            // Consent-gated, fire-and-forget; never affects the registration result
                            trackSignUp( userData.region );
                        }
                        else
                        {
                            throw new Error();
                        }
                    }
                    catch( e )
                    {
                        switch ( +e.status )
                        {
                            case 409:
                                mainWrapper.querySelector( '[data-id="register-error-container"]' ).innerText = 'Email already exists';
                            break;

                            default:
                                mainWrapper.querySelector( '[data-id="register-error-container"]' ).innerText = 'Error during registration. Please try again later.';
                        }
                        mainWrapper.querySelector( '[data-id="register-error-container"]' ).style.display = 'block';
                    }

                    mainWrapper.querySelector( '[data-id="btn-register-loading"]' ).style.display = 'none';
                    mainWrapper.querySelector( '[data-id="btn-register"]' ).style.display = 'block';
                }
                else
                {
                    form.classList.add('was-validated');
                }
            }
        );
    }
    async exit()
    {
        destroyHeroShader();
        const mainWrapper = this.app.container.querySelector('#main-wrapper' );
        mainWrapper.querySelector( '[data-id="register-form-container"]' ).style.display = 'block';
        mainWrapper.querySelector( '[data-id="register-success-container"]' ).style.display = 'none';
    }
}
